import Axios from 'axios';

export const axios = Axios.create({
  timeout: 6000,
  withCredentials: true,
});
